import MethodPill from "@/components/ui/common/method-pill";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import BodyFieldTree from "./body-field-tree";
import ParameterTable from "./parameter-table";

const EndpointRow = ({ endpoint }) => {
	const [expandLevel, setExpandLevel] = useState(0);

	const hasParams = endpoint.request?.parameters?.length > 0;
	const hasRequestBody = endpoint.request?.bodyFields?.length > 0;
	const hasResponseBody = endpoint.response?.bodyFields?.length > 0;
	const hasDetail = hasParams || hasRequestBody || hasResponseBody;

	const maxLevel = hasDetail ? (hasRequestBody || hasResponseBody ? 2 : 1) : 0;

	const handleClick = () => {
		if (!hasDetail) return;
		setExpandLevel((prev) => (prev >= maxLevel ? 0 : prev + 1));
	};

	const highlightPath = (path) => {
		return path?.split(/(\{[^}]+\})/).map((part, i) =>
			part.startsWith("{") ? (
				<span key={i} className="text-[#EFD948]">
					{part}
				</span>
			) : (
				<span key={i}>{part}</span>
			)
		);
	};

	return (
		<div className="border-b border-border/30 last:border-b-0">
			<button onClick={handleClick} className="flex items-center w-full px-3 py-2 hover:bg-accent/50 transition-colors text-left bg-transparent">
				<MethodPill method={endpoint.method} />
				<span className="ml-2 font-mono text-sm text-gray-200 truncate flex-1">{highlightPath(endpoint.path)}</span>
				{hasDetail && (
					<span className="ml-2 text-gray-500">
						{expandLevel > 0 ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
					</span>
				)}
			</button>
			{expandLevel >= 1 && (
				<div className="px-3 pb-2 bg-background/50">
					<ParameterTable parameters={endpoint.request?.parameters} />
					{expandLevel >= 2 && (
						<>
							<BodyFieldTree fields={endpoint.request?.bodyFields} label="Request Body" />
							<BodyFieldTree fields={endpoint.response?.bodyFields} label="Response Body" />
						</>
					)}
					{expandLevel === 1 && (hasRequestBody || hasResponseBody) && (
						<button
							onClick={(e) => {
								e.stopPropagation();
								setExpandLevel(2);
							}}
							className="text-[10px] text-primary hover:underline mt-1 bg-transparent border-none p-0"
						>
							Show request/response body
						</button>
					)}
				</div>
			)}
		</div>
	);
};

export default EndpointRow;
